/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Presentation Chart Line (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgPresentationChartLine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m37 42 3-3 3 3 4-4m-9 13 4-4 4 4M33 34h18m-17 0h16v12a1 1 0 0 1-1 1H35a1 1 0 0 1-1-1z"
    />
  </svg>
);
export default SvgPresentationChartLine;
